export default __webpack_public_path__ + "static/media/Calendar.d0102c23.webm";